import { FETCHED_INCIDENT_DATA } from "@@/constants/IncidentConstants";
import { CreateStore, withPayload } from "@selkirk-systems/state-management";

/**
 * All Store data must be Immutable.
 * Use StateManagement/StoreUpdater helper functions or
 * import {update} from "@mbernal/simple-immutable"
 * and always return new state in response to dispatches.
 *
 */

const SummaryStore = CreateStore({
    name: "SummaryStore",

    events: {
        [FETCHED_INCIDENT_DATA]:withPayload("incidentSummaryList").setValues("summaries")
    },

    state: {
        summaries:null
    },
});

export default SummaryStore;
